import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { useSearchableMenu } from 'shared/domains/common-ui/SearchableMenu';
export function ListSelectionAddItem(props) {
    const { onAdd } = props;
    const { submitForm } = useFormikContext();
    const { searchString } = useSearchableMenu();
    const handleAdd = () => {
        onAdd(searchString);
        return submitForm();
    };
    return (<Menu.Item onClick={handleAdd}>
      <Trans comment="Metadata: Add new value - No search result">Add {searchString}</Trans>
    </Menu.Item>);
}
